import axios from "axios";
import CryptoJS from "crypto-js";

var body = {
    "customerCode": "ICRME000SRN93", 
    "declaredCurrency": "USD", 
    "declaredValue": 10, 
    "orderOperateType": "1", 
    "parcelQuantity": 2, 
    "parcelTotalWeight": 0.5, 
    "parcelWeightUnit": "KG", 
    "parcelVolumeUnit": "CM", 
    "parcelTotalLength": "1", 
    "parcelTotalWidth": "1", 
    "parcelTotalHeight": "1", 
    "pickupAppointTime": "", 
    "pickupAppointTimeZone": "", 
    "pickupType": "0", 
    "remark": "", 
    "sfWaybillNo": "", 
    "version": "", 
    "customerOrderNo": "lhtest02201676882283440", 
    "customerOrderNoTwo": "", 
    "interProductCode": "INT0014", 
    "isBbd": 1, 
    "agentWaybillNo": "AG202007060053",
    "paymentInfo": {
        "payMethod": "1", 
        "payMonthCard": "0270000250", 
        "taxPayMethod": "2", 
        "taxPayMonthCard": ""
    },
    "addServiceInfoList": [
        {
            "serviceCode": "", 
            "value": "", 
            "valueOne": ""
        }
    ],  
    "childInfoList": [
        {
            "sfWaybillNo": "", 
            "length": "1.31", 
            "width": "2.31", 
            "height": "3.21", 
            "weight": "4.21"
        },
        {
            "sfWaybillNo": "", 
            "length": "1.31", 
            "width": "2.31", 
            "height": "3.21", 
            "weight": "4.21"
        }
    ], 
    "customsInfo": {
        "aesNo": "", 
        "businessRemark": "", 
        "customsBatch": "", 
        "harmonizedCode": "", 
        "senderReasonContent": "", 
        "tradeCondition": ""
    }, 
    "orderExtendInfo": {
        "isSelfPick": "", 
        "isSignBack": "", 
        "signBackWaybillNo": "", 
        "businessMode": "0", 
        "senderDeptCode": "755A", 
        "operEmpCode": "000212"
    }, 
    "parcelInfoList": [
        {
            "amount": 0.1, 
            "brand": "", 
            "currency": "", 
            "goodsCode": "", 
            "goodsDesc": "", 
            "goodsUrl": "", 
            "hsCode": "", 
            "name": "iPhone", 
            "originCountry": "SG", 
            "productCustomsNo": "", 
            "productRecordNo": "", 
            "quantity": 1, 
            "stateBarCode": "", 
            "unit": "个"
        }
    ], 
    "receiverInfo": {
        "address": "新加坡 详细地址", 
        "cargoType": 1, 
        "certCardNo": "430527199309204211", 
        "certType": "001", 
        "company": "", 
        "contact": "李想", 
        "country": "CN", 
        "email": "iuop@test.com", 
        "eori": "", 
        "phoneAreaCode": "86", 
        "phoneNo": "18888800000", 
        "postCode": "536727", 
        "telAreaCode": "86", 
        "telNo": "9516168888", 
        "vat": "",
        "regionFirst": "guang dong",
        "regionSecond": "shen zhen",
        "regionThird": "bao an"
    }, 
    "senderInfo": {
        "address": "306 S BRYN MAWR AVE", 
        "cargoType": 1, 
        "certCardNo": "", 
        "certType": "001", 
        "company": "", 
        "contact": "宏宏宏少", 
        "country": "US", 
        "email": "iuop@test.com", 
        "eori": "", 
        "phoneAreaCode": "65", 
        "phoneNo": "54875485", 
        "postCode": "759973", 
        "telAreaCode": "86", 
        "telNo": "9516168888", 
        "vat": "",
        "regionFirst": "Alaska",
        "regionSecond": "Juneau",
        "regionThird": "Borough"
    }, 
    "ecommerceInfo": {
        "actPay": 1221, 
        "applicationNo": "1231231321", 
        "buyerEmail": "12312@dd.com", 
        "buyerFreight": 123132, 
        "buyerNickname": "zhagnsan21", 
        "buyerPremium": 122, 
        "currency": "TWD", 
        "enterpriseCheckCode": "1232", 
        "enterpriseCrossCode": "12342", 
        "enterpriseCustomsCode": "电商企业的海关注册登记编号21", 
        "enterpriseName": "电商企业的海关注册登记编号2", 
        "payEnterpriseCheckCode": "22212", 
        "payEnterpriseCustomsCode": "22222", 
        "payNo": "123123123", 
        "payTime": "2022-03-31 15:01:42", 
        "payToolType": "zhifubao", 
        "payerCertNo": "3331", 
        "payerCertType": "001", 
        "payerName": "zhifubao", 
        "payerTel": "1231231231", 
        "platformCheckCode": "44441", 
        "platformCustomsCode": "电商平台的海关注册登记编号", 
        "platformDomainName": "ali.com", 
        "platformName": "电商平台的海关注册登记名称", 
        "preferentialAmount": 12312, 
        "promotionType": "1", 
        "sellerAlipayNo": "5551", 
        "sellerEmail": "1312@ww.com", 
        "sellerNickname": "lisi2", 
        "shopWebCode": "购物网站代码21", 
        "storeCode": "12378", 
        "tax": "6666"
    }
}

function getSignature(token, timestamp, nonce, encryptedMsg) {
  try {
    const str = [token, timestamp, nonce, encryptedMsg];
    str.sort();
    var s = str.join("");
    return CryptoJS.SHA256(s).toString();
  } catch (err) {
    console.error(err.message);
  }
}

function PKCS7Encode(length) {
  var amountPad = 32 - (length % 32);
  if (amountPad === 0) {
    amountPad = 32;
  }
  var padChr = String.fromCharCode(amountPad);
  var tmpData = "";
  for (var i = 0; i < amountPad; i++) {
    tmpData += padChr;
  }
  return tmpData;
}

function PKCS7Decode(decrypted) {
  var padStrArr = CryptoJS.lib.WordArray.create(
    [...decrypted.words].slice(
      decrypted.words.length - 1,
      decrypted.words.length
    )
  );
  var padStr = CryptoJS.enc.Utf8.stringify(padStrArr);
  var pad = padStr.substr(padStr.length - 1, padStr.length).charCodeAt();
  if (pad < 1 || pad > 32) {
    pad = 0;
  }
  const arrPad = Math.ceil(pad / 4);
  padStr = CryptoJS.enc.Utf8.stringify(
    CryptoJS.lib.WordArray.create(
      [...decrypted.words].slice(
        decrypted.words.length - arrPad,
        decrypted.words.length
      )
    )
  );
  const endStr = CryptoJS.enc.Utf8.parse(padStr.substr(0, padStr.length - pad));
  var copyDecrypted = CryptoJS.lib.WordArray.create(
    [...decrypted.words].slice(0, decrypted.words.length - arrPad)
  );
  return copyDecrypted.concat(endStr);
}

function pack(length) {
  var first = CryptoJS.enc.Latin1.parse(
    String.fromCharCode((length >> 24) & 0xff)
  );
  var sencond = CryptoJS.enc.Latin1.parse(
    String.fromCharCode((length >> 16) & 0xff)
  );
  var third = CryptoJS.enc.Latin1.parse(
    String.fromCharCode((length >> 8) & 0xff)
  );
  var forth = CryptoJS.enc.Latin1.parse(String.fromCharCode(length & 0xff));
  first.concat(sencond);
  first.concat(third);
  first.concat(forth);
  return first;
}

function unpack(network) {
  var sourceNumber = 0;
  for (var i = 0; i < 4; i++) {
    sourceNumber <<= 8;
    sourceNumber |= network.substr(i, i + 1).charCodeAt() & 0xff;
  }
  return sourceNumber;
}

export class AesCrypt {
  key;
  constructor(k) {
    this.key = k + "=";
  }
  async encrypt(text, appid) {
    try {
      const random = await this.getRandomStr();
      const appidWA = CryptoJS.enc.Utf8.parse(appid);
      const randomWA = CryptoJS.enc.Utf8.parse(random);
      const textWA = CryptoJS.enc.Utf8.parse(text);
      const packedArr = await pack(textWA.sigBytes);
      randomWA.concat(packedArr);
      randomWA.concat(textWA);
      randomWA.concat(appidWA);
      var dataWA = randomWA;
      // AES require input length not multiple of 16 bytes
      var padData = PKCS7Encode(dataWA.sigBytes);
      const padDataWA = CryptoJS.enc.Utf8.parse(padData);
      dataWA.concat(padDataWA);
      var keyWA = CryptoJS.enc.Base64.parse(this.key);
      // iv = key(0,16)
      const ivWords = [...keyWA.words].splice(0, 4);
      const iv = CryptoJS.lib.WordArray.create(ivWords);
      const encrypted = CryptoJS.AES.encrypt(dataWA, keyWA, {
        iv: iv,
        padding: CryptoJS.pad.NoPadding,
        mode: CryptoJS.mode.CBC,
      });
      return encrypted.toString();
    } catch (err) {
      console.log("AesCrpty err", err.message);
    }
  }

  async decrypt(encrypted, appKey) {
    try {
      var keyWA = CryptoJS.enc.Base64.parse(this.key);
      const ivWords = [...keyWA.words].splice(0, 4);
      const iv = CryptoJS.lib.WordArray.create(ivWords);
      const decryptMsg = CryptoJS.AES.decrypt(encrypted, keyWA, {
        iv: iv,
        padding: CryptoJS.pad.NoPadding,
        mode: CryptoJS.mode.CBC,
      });
      //const ivCiphertext = iv.clone().concat(ciphertext);
      var dataMsg = PKCS7Decode(decryptMsg);
      var network = CryptoJS.enc.Latin1.stringify(
        CryptoJS.lib.WordArray.create([...dataMsg.words].slice(4, 5))
      );
      const dataLength = unpack(network);
      var contentArr = CryptoJS.lib.WordArray.create(
        [...dataMsg.words].slice(5, dataMsg.words.length)
      );
      var contentStr = CryptoJS.enc.Utf8.stringify(contentArr);
      var index = contentStr.indexOf(appKey);
      if (index > -1) {
        contentStr = contentStr.substr(0, index);
      }
      return contentStr;
    } catch (err) {
      console.error(err.message);
    }
  }

  async getRandomStr() {
    let str = "";
    const str_pol =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789abcdefghijklmnopqrstuvwxyz";
    const max = str_pol.length - 1;
    for (let i = 0; i < 16; i++) {
      const r = await this.mtRand(0, max);
      str = str + str_pol[r];
    }
    return str;
  }
  mtRand(min, max) {
    const argc = arguments.length;
    if (argc === 0) {
      min = 0;
      max = 2147483647;
    } else if (argc === 1) {
      throw new Error(
        "Warning: mt_rand() expects exactly 2 parameters, 1 given"
      );
    } else {
      min = parseInt(min, 10);
      max = parseInt(max, 10);
    }
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }
}

export class BizMsgCrypt {
  token;
  encodingAesKey;
  appId;
  constructor(token, encodingAesKey, appId) {
    this.token = token;
    if (encodingAesKey.length !== 43) {
      throw new Error("invalid aes key");
    }
    this.encodingAesKey = encodingAesKey;
    this.appId = appId;
  }
  async encryptMsg(replyMsg, timestamp, nonce) {
    const ac = new AesCrypt(this.encodingAesKey);
    const encrypt = await ac.encrypt(replyMsg, this.appId);
    const signature = await getSignature(
      this.token,
      timestamp + "",
      nonce + "",
      encrypt
    );

    return {
      encrypt,
      signature,
      timestamp,
      nonce,
    };
  }
  async decryptMsg(timestamp, nonce, encrypt) {
    const ac = new AesCrypt(this.encodingAesKey);
    const decrypt = await ac.decrypt(encrypt, this.appId);
    return decrypt;
  }
}

export const createOrder = async() => {
    var appKey = "cdd169d87a4698d314754a79f180308a";
    var aesKey = "oI1YdU1cb1YC70HVjZRa3wXBLUsrIUYr5lDh0gFrMbe";
    var token = "auth_fba5c391-a751-4f47-a394-c6f0bb3c4130_1638339241848";
    var nonce = "123";
    const time = "1681704835762";
    const pc = new BizMsgCrypt(token, aesKey, appKey);
    const strData = "{\"customerCode\":\"ICRME000SRN93\",\"declaredCurrency\":\"USD\",\"declaredValue\":10,\"orderOperateType\":\"1\",\"parcelQuantity\":2,\"parcelTotalWeight\":0.5,\"parcelWeightUnit\":\"KG\",\"parcelVolumeUnit\":\"CM\",\"parcelTotalLength\":\"1\",\"parcelTotalWidth\":\"1\",\"parcelTotalHeight\":\"1\",\"pickupAppointTime\":\"\",\"pickupAppointTimeZone\":\"\",\"pickupType\":\"0\",\"remark\":\"\",\"sfWaybillNo\":\"\",\"version\":\"\",\"customerOrderNo\":\"lhtest02201681451538245\",\"customerOrderNoTwo\":\"\",\"interProductCode\":\"INT0014\",\"isBbd\":0,\"agentWaybillNo\":\"AG202007060053\",\"paymentInfo\":{\"payMethod\":\"1\",\"payMonthCard\":\"0270000250\",\"taxPayMethod\":\"2\",\"taxPayMonthCard\":\"\"},\"addServiceInfoList\":[{\"serviceCode\":\"\",\"value\":\"\",\"valueOne\":\"\"}],\"childInfoList\":[{\"sfWaybillNo\":\"\",\"length\":\"1.31\",\"width\":\"2.31\",\"height\":\"3.21\",\"weight\":\"4.21\"},{\"sfWaybillNo\":\"\",\"length\":\"1.31\",\"width\":\"2.31\",\"height\":\"3.21\",\"weight\":\"4.21\"}],\"customsInfo\":{\"aesNo\":\"\",\"businessRemark\":\"\",\"customsBatch\":\"\",\"harmonizedCode\":\"\",\"senderReasonContent\":\"\",\"tradeCondition\":\"\"},\"orderExtendInfo\":{\"isSelfPick\":\"\",\"isSignBack\":\"\",\"signBackWaybillNo\":\"\",\"businessMode\":\"0\",\"senderDeptCode\":\"755A\",\"operEmpCode\":\"000212\"},\"parcelInfoList\":[{\"amount\":0.1,\"brand\":\"\",\"currency\":\"\",\"goodsCode\":\"\",\"goodsDesc\":\"\",\"goodsUrl\":\"\",\"hsCode\":\"\",\"name\":\"iPhone\",\"originCountry\":\"SG\",\"productCustomsNo\":\"\",\"productRecordNo\":\"\",\"quantity\":1,\"stateBarCode\":\"\",\"unit\":\"个\"}],\"receiverInfo\":{\"address\":\"新加坡 详细地址\",\"cargoType\":1,\"certCardNo\":\"430527199309204211\",\"certType\":\"001\",\"company\":\"\",\"contact\":\"李想\",\"country\":\"CN\",\"email\":\"iuop@test.com\",\"eori\":\"\",\"phoneAreaCode\":\"86\",\"phoneNo\":\"18888800000\",\"postCode\":\"536727\",\"telAreaCode\":\"86\",\"telNo\":\"9516168888\",\"vat\":\"\",\"regionFirst\":\"guang dong\",\"regionSecond\":\"shen zhen\",\"regionThird\":\"bao an\"},\"senderInfo\":{\"address\":\"306 S BRYN MAWR AVE\",\"cargoType\":1,\"certCardNo\":\"\",\"certType\":\"001\",\"company\":\"\",\"contact\":\"宏宏宏少\",\"country\":\"US\",\"email\":\"iuop@test.com\",\"eori\":\"\",\"phoneAreaCode\":\"65\",\"phoneNo\":\"54875485\",\"postCode\":\"759973\",\"telAreaCode\":\"86\",\"telNo\":\"9516168888\",\"vat\":\"\",\"regionFirst\":\"Alaska\",\"regionSecond\":\"Juneau\",\"regionThird\":\"Borough\"},\"ecommerceInfo\":{\"actPay\":1221,\"applicationNo\":\"1231231321\",\"buyerEmail\":\"12312@dd.com\",\"buyerFreight\":123132,\"buyerNickname\":\"zhagnsan21\",\"buyerPremium\":122,\"currency\":\"TWD\",\"enterpriseCheckCode\":\"1232\",\"enterpriseCrossCode\":\"12342\",\"enterpriseCustomsCode\":\"电商企业的海关注册登记编号21\",\"enterpriseName\":\"电商企业的海关注册登记编号2\",\"payEnterpriseCheckCode\":\"22212\",\"payEnterpriseCustomsCode\":\"22222\",\"payNo\":\"123123123\",\"payTime\":\"2022-03-31 15:01:42\",\"payToolType\":\"zhifubao\",\"payerCertNo\":\"3331\",\"payerCertType\":\"001\",\"payerName\":\"zhifubao\",\"payerTel\":\"1231231231\",\"platformCheckCode\":\"44441\",\"platformCustomsCode\":\"电商平台的海关注册登记编号\",\"platformDomainName\":\"ali.com\",\"platformName\":\"电商平台的海关注册登记名称\",\"preferentialAmount\":12312,\"promotionType\":\"1\",\"sellerAlipayNo\":\"5551\",\"sellerEmail\":\"1312@ww.com\",\"sellerNickname\":\"lisi2\",\"shopWebCode\":\"购物网站代码21\",\"storeCode\":\"12378\",\"tax\":\"6666\"}}";
    const result = await pc.encryptMsg(strData, time, nonce);
    const { signature, encrypt, timestamp } = result;

    var settings = {
    "url": "https://api-ifsp.sit.sf.global/openapi/api/dispatch",
    "method": "POST",
    "timeout": 0,
    "headers": {
        "appKey": appKey,
        "token": token,
        "timestamp": timestamp,
        "nonce": nonce,
        "signature": signature,
        "msgType": "IUOP_CREATE_ORDER",
        "lang": "zh-CN",
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        'Access-Control-Allow-Headers': '*',
        'Access-Control-Allow-Credentials': true,
    },
    "data":encrypt,
    };

    fetch(settings.url,settings).then(
        (res) => console.log(res)
    )
    console.log(settings)
}

export const demsg = async() => {
    var appKey = "cdd169d87a4698d314754a79f180308a";
    var aesKey = "oI1YdU1cb1YC70HVjZRa3wXBLUsrIUYr5lDh0gFrMbe";
    var token = "auth_fba5c391-a751-4f47-a394-c6f0bb3c4130_1638339241848";
    var nonce = "123";
    const time = "1681704835762";
    const word = "wmR1nqnzKHUBB2nM5RNhaDJLN47gG+GXchBFRjLYQLrelj5gdMjxdaSjvjjGZ7Yh2ghzGOsu+EoNqNhnb+bQNmXpDToaD3fPXvXGxHIoe2xwwje1cp2LZGfLVUtd17eihQyiLQS1iDaGc14EWa+9Dujz4PVUfsCcIrn5DeMHYoolOG5CMJ4nD2Dxwlv7B6LvbH/TxPCL48sCUJQ5oWbt/w=="
    // const msg = CryptoJS.enc.Base64.parse(word).toString(CryptoJS.enc.Utf8);
    // console.log(msg)
    const pc = new BizMsgCrypt(token, aesKey, appKey);
    pc.decryptMsg(time, nonce, word).then(
        (res) => console.log(JSON.parse(res))
    )
}